'use client';

import { useAuth } from '@/providers/auth-provider';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface AuthGateProps {
  requiredRole?: 'user' | 'admin' | 'super_admin';
}

export function AuthGate({ requiredRole = 'user' }: AuthGateProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="flex flex-col items-center gap-4">
          <div className="relative flex h-16 w-16">
            <div className="animate-spin absolute inset-0 rounded-full border-4 border-slate-700" />
            <div className="absolute inset-0 rounded-full border-4 border-cyan-500 border-t-transparent" />
          </div>
          <p className="text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole === 'admin' && !['admin', 'super_admin'].includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  if (requiredRole === 'super_admin' && user.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}